var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivFitPreferredIconRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    viewBox: "0 0 40 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 8C17.78 8 16 9.78 16 12C16 14.22 17.78 16 20 16C22.22 16 24 14.22 24 12C24 9.78 22.22 8 20 8ZM40 0V10H36V6H4V10H0L0 0L4 0V4H36V0L40 0ZM26 20.52V44H22V34H18V44H14V20.52C9.86 18.34 7 14 7 9V8H11V9C11 14 15 18 20 18C25 18 29 14 29 9V8H33V9C33 14 30.14 18.34 26 20.52Z",
    fill: "#C7222A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivFitPreferredIconRed);
export default __webpack_public_path__ + "static/media/ActivFitPreferredIcon-red.c3e56228aa3ca4fbc83fd91047beda08.svg";
export { ForwardRef as ReactComponent };